import { api, currentCreche } from '../api'

const ActivityRepository = {
    categories () {
        return api().$get('/activity-categories')
    },

    getAll (query = {}) {
        return api().$get(`/${currentCreche().uuid}/activities`, query)
    },

    index (registrationUuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/registrations/${registrationUuid}/activities`, query)
    },

    create (registrationUuid, payload) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/activities`, payload)
    },

    update (activityUuid, registrationUuid, payload) {
        return api().$put(`/${currentCreche().uuid}/registrations/${registrationUuid}/activities/${activityUuid}`, payload)
    },

    addAttachment (activityUuid, registrationUuid, payload) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/activities/${activityUuid}/attachment`, payload)
    },

    delete (activityUuid, registrationUuid) {
        return api().$delete(`/${currentCreche().uuid}/registrations/${registrationUuid}/activities/${activityUuid}`)
    },

    createMultiple (payload) {
        return api().$post(`/${currentCreche().uuid}/activities`, payload)
    },

    exportToExcel (payload) {
        return api().$get(`/${currentCreche().uuid}/activities/export`, payload, { download: true })
    }
}

export default ActivityRepository
